import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Box } from '@mui/material';
import { AppointmentRequestStatus } from 'apps/wrapper/src/services/appointment/types/appointment-request-status';
import { AppointmentRequestSummary } from 'apps/wrapper/src/services/appointment/types/appointment-request-summary';
import { PmsWritebackStatus } from 'apps/wrapper/src/services/appointment/types/pms-writeback-status';
import moment from 'moment';
import { FC, useMemo } from 'react';
import {
  AiStatus,
  AppointmentTime,
  AppointmentTimes,
  AppointmentType,
  BlueDot,
  DateAndType,
  GoToDetailsButton,
  ListItem,
  ListItemContent,
  ListItemFooter,
  ListItemHover,
  ListItemStatus,
  ListItemTitle,
  ListItemWrapper,
  PatientName,
  PatientNameWrapper,
  RequestComment,
  RequestDate,
  RequestType,
  StatusIcons,
  StatusMessage
} from './appt-request-list-item.styles';
import { IvStatus } from './iv-status/iv-status';
import { StatusMessageFactory } from './status-message-factory/status-message-factory';

export interface ApptRequestListItemProps {
  appointmentRequest: AppointmentRequestSummary;
  onClick: (apptRequest: AppointmentRequestSummary) => void;
}

export const ApptRequestListItem: FC<ApptRequestListItemProps> = (props) => {
  const { appointmentRequest, onClick } = props;

  const renderAppointmentTimes = useMemo(() => {
    const dateTimeFormat = 'MM/DD/YYYY [at] h:mm a';

    if (appointmentRequest.appointmentRequestTimes && appointmentRequest.appointmentRequestTimes.length > 0) {
      return appointmentRequest.appointmentRequestTimes.map((time) => (
        <AppointmentTime key={time.dateStart}>{moment(time.dateStart).format(dateTimeFormat)}</AppointmentTime>
      ));
    }

    return null;
  }, [appointmentRequest]);

  return (
    <ListItemWrapper>
      <ListItemHover
        isdirectbooking={appointmentRequest.isDirectlyBooked ? 'true' : 'false'}
        onClick={() => onClick(appointmentRequest)}
      >
        <ListItemStatus>{appointmentRequest.status === AppointmentRequestStatus.New && <BlueDot />}</ListItemStatus>
        <ListItem>
          <ListItemTitle>
            <PatientNameWrapper>
              <PatientName>{`${appointmentRequest?.patient?.firstName} ${appointmentRequest?.patient?.lastName}`}</PatientName>
            </PatientNameWrapper>
            <DateAndType>
              <RequestDate>{moment(appointmentRequest.createdDate).format('MM/DD/YYYY')}</RequestDate>
              <RequestType>
                {appointmentRequest.isRescheduleRequest
                  ? 'Rescheduling'
                  : appointmentRequest.isCancelRequest
                  ? 'Cancelling'
                  : 'Appointment'}
              </RequestType>
            </DateAndType>
          </ListItemTitle>
          <ListItemContent>
            <Box sx={{ flexDirection: 'column', display: 'flex' }}>
              <AppointmentType>
                {appointmentRequest.isRescheduleRequest || appointmentRequest.isCancelRequest
                  ? appointmentRequest.originalAppointmentType
                  : appointmentRequest.appointmentType}
              </AppointmentType>
              <AppointmentTimes>{renderAppointmentTimes}</AppointmentTimes>
              <RequestComment>{appointmentRequest.comment || appointmentRequest.patientNote}</RequestComment>
            </Box>
          </ListItemContent>
          <ListItemFooter>
            <StatusMessage>
              <StatusMessageFactory appointmentRequest={appointmentRequest} />
            </StatusMessage>
            <StatusIcons>
              <IvStatus appointmentRequest={appointmentRequest} />
              {appointmentRequest.milaCaseId && <AiStatus />}
            </StatusIcons>
          </ListItemFooter>
        </ListItem>
      </ListItemHover>
      {(appointmentRequest.pmsWritebackStatus === PmsWritebackStatus.Error ||
        appointmentRequest.status == AppointmentRequestStatus.New ||
        appointmentRequest.status == AppointmentRequestStatus.Pending) &&
        !appointmentRequest.isDirectlyBooked && (
          <GoToDetailsButton onClick={() => onClick(appointmentRequest)}>
            <ArrowForwardIosIcon />
          </GoToDetailsButton>
        )}
    </ListItemWrapper>
  );
};
